/* Dependencies
 ----------------------------------------------------------*/
import {Application} from "wrapper6";

/* Vendor
 ----------------------------------------------------------*/


/* Setup
 ----------------------------------------------------------*/
var app = window.app = new Application(window.options || {});

/* Services
 ----------------------------------------------------------*/


/* Register services
 ----------------------------------------------------------*/

/* Modules
 ----------------------------------------------------------*/
import Navigation from "../modules/_navigation";
import ObjectFit from "../modules/_object-fit";
import Print from "../modules/_print";
// import InstagramFeed from "../modules/_insta-feed";
import BigSlider from "../modules/_big-slider";
import LatestPostsFilter from "../modules/_latest-posts-filter";
import Slider from "../modules/_slider";
import CoverScrol from "../modules/_cover-scroll";
import RoomsFilter from "../modules/_rooms-filter";
import RoomsCoverSlider from "../modules/_rooms-cover-slider";
import GalleryModal from "../modules/_gallery-modal";
import NewsFilter from "../modules/_news-filter";
import SmoothScroll from "../modules/_smooth-scroll";
import VideoModal from "../modules/_video-modal";
import Modal from "../modules/_modal";

/* Register modules
 ----------------------------------------------------------*/
app.use(Navigation);
app.use(ObjectFit);
app.use(Print);
// app.use(InstagramFeed);
app.use(BigSlider);
app.use(LatestPostsFilter);
app.use(Slider);
app.use(CoverScrol);
app.use(RoomsFilter);
app.use(RoomsCoverSlider);
app.use(GalleryModal);
app.use(NewsFilter);
app.use(SmoothScroll);
app.use(VideoModal);
app.use(Modal);


// WEBPACK FOOTER //
// ./resources/js/public/main.js